(ns leg.auth
  "Whether this window may talk to the server, and where its key is kept.

  One key per client, handed out once when a code was typed back, and shown
  as a bearer header from then on. It lives in localStorage: what is stored
  is not a password but this one device's key, and the server can take it
  away by forgetting the client it belongs to (see leser.auth)."
  (:require [kc.core :as kc]))

(def storage-key "leser.auth.v1")

(def email-key
  "Where the last address used here is kept. Not a credential - it is the
  thing the person would type again anyway, and typing an address on a phone
  is the part of signing in that nobody enjoys."
  "leser.email.v1")

(defonce !auth (atom {:needed? false :client nil}))

(defn- storage []
  (when (exists? js/localStorage) js/localStorage))

(defn token []
  (when-let [s (storage)]
    (try (.getItem s storage-key) (catch :default _ nil))))

(defn save-token! [t]
  (when-let [s (storage)]
    (try (.setItem s storage-key t) (catch :default _ nil))))

(defn- clear-token! []
  (when-let [s (storage)]
    (try (.removeItem s storage-key) (catch :default _ nil))))

(defn needed!
  "The key this window had, if it had one, is no good any more - thrown away
  rather than kept and sent with every failing request until someone
  notices."
  []
  (when-not (:needed? @!auth)
    (clear-token!)
    (swap! !auth assoc :needed? true)))

(defn ok!
  "A call came back, so whatever key this window has is good. Guarded,
  because a needless swap is a needless redraw."
  []
  (when (:needed? @!auth)
    (swap! !auth assoc :needed? false)))

(defn satisfied!
  "A code was traded for a key. `client` is what the server said this window
  now is, kept so the settings can show which device it is."
  [client]
  (swap! !auth assoc :needed? false :client client))

(defn sign-out!
  "Forget the key here. The client is still known to the server - taking it
  away there is what the settings screen does - but this window has to ask
  again."
  []
  (clear-token!)
  (swap! !auth assoc :needed? true :client nil))

(defn last-email []
  (when-let [s (storage)]
    (try (.getItem s email-key) (catch :default _ nil))))

(defn remember-email! [e]
  (when-let [s (storage)]
    (try (.setItem s email-key e) (catch :default _ nil))))

(defn headers []
  (when-let [t (kc/str-trimmed-non-blank (token))]
    {"authorization" (str "Bearer " t)}))
